import React, { useContext } from "react";
import { TaskContext } from "../contexts/task";
import { SHIPMENT_TYPE_MAP } from "./shipments/lib/constants";
import { BRAND_VERIFIED_LOCATION } from "components/shipment-editor/lib/constants";
import { AttributesContext } from "contexts/attributes";
import { getProductName } from "shared/product-name";
import { useMainWipProductName } from "shared/hooks/api/use-main-wip-product-name";

const HeaderUpc = (props) => {
    const { task } = useContext(TaskContext);
    const attributes = useContext(AttributesContext);
    const taskProductName = getProductName(props.productData || attributes?.data);
    const { data: mainWipProductName } = useMainWipProductName(task.context.codingWipKey, { enabled: !taskProductName });
    const productName = taskProductName || mainWipProductName;
    const label = props.isBrandVerified ? BRAND_VERIFIED_LOCATION : SHIPMENT_TYPE_MAP[task?.context.shipmentType].label;
    document.title = task.fullUpc;

    return (
        <h1 className="m-l-12 txt-nowrap flex align-center min-width-0 header-title -lowercase">
            <span className="memo m-r-1">{task.fullUpc}</span>
            {task.context.shipmentType >= 0 && <span className="memo mr-1">({label})</span>}
            {productName && (
                <span
                    className="memo ellipsis -capped"
                    title={productName}
                >
                    {productName}
                </span>
            )}
        </h1>
    );
};

export default HeaderUpc;
